





import { Component, Vue } from 'vue-property-decorator';
import Icon from '@/components/common/icon.vue';
import { SidebarModuleMapper } from '@/store/modules/sidebar';

const Mappers = Vue.extend({
  computed: SidebarModuleMapper.mapGetters(['sidebarState']),
  methods: {
    ...SidebarModuleMapper.mapMutations({
      toggle: 'toggle',
    }),
  },
});

@Component({
  components: {
    Icon,
  },
})
export default class SideBarToggleComponent extends Mappers {
  closeSidebar() {
    this.toggle(!this.sidebarState);
  }
}
